import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';

// components
import PatientDetailDiaryLineChart from "../../chart/patientDetailPage/PatientDetailDiaryLineChart";

// api
import getDoNotDrinkDiaryFromAlcohol from "../../../../services/apis/alcohol/diary";


// Date객체를 YYYYMMDD 형식의 문자열로 변형
function convertDate(dateObj) {
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth()+1;
    const date = dateObj.getDate();

    return `${year}${month.toString().padStart(2, '0')}${date.toString().padStart(2, '0')}`;
}

// YYYYMMDD 형식의 문자열을 YYYY-MM-DD 형식의 문자열로 변형
function convertDateString(YYYYMMDD) {
    return `${YYYYMMDD.slice(0,4)}-${YYYYMMDD.slice(4,6)}-${YYYYMMDD.slice(6,8)}`;
}

// 두 날짜를 포함한 사이의 일수 구하기
const getDateDiff = (d1, d2) => {
    const date1 = new Date(d1);
    const date2 = new Date(d2);
    
    const diffDate = date1.getTime() - date2.getTime();
    
    return Math.abs(diffDate / (1000 * 60 * 60 * 24)) + 1; // 밀리세컨 * 초 * 분 * 시 = 일
}


function CalendarBox({calendarList, diaryData, diaryInfo, startDate, endDate, handleClickWeekBtn, handleClickCalendarItem}) {

    // 금주 실천 underline type 출력 => underline_both / underline_left / underline_right
    const printUnderline = (curIdx) => {
        let leftFlag = 0;
        let rightFlag = 0;

        try{
            if(curIdx%7===0) throw new Error();
            if(diaryData[calendarList[curIdx-1].date].drinking==="금주") leftFlag=1;
        }catch(err){
            leftFlag=0;
        }

        try{
            if(curIdx%7===6) throw new Error();
            if(diaryData[calendarList[curIdx+1].date].drinking==="금주") rightFlag=1;
        }catch(err){            
            rightFlag=0;
        }

        if(leftFlag && rightFlag) {
            return "underline_both"
        }else if(leftFlag) {
            return "underline_left"
        }else if(rightFlag) {
            return "underline_right"
        }else{
            return ""
        }
    }

    return (
        <div className="diary_box1">
            <div className="diary_calender_wrapper">
                <div className="box1_header">
                    <span>금주일지</span>
                    <div className="header_button_list">
                        <button onClick={()=>handleClickWeekBtn(1)}>1주</button>
                        <button onClick={()=>handleClickWeekBtn(2)}>2주</button>
                        <button onClick={()=>handleClickWeekBtn(4)}>4주</button>
                        <button onClick={()=>handleClickWeekBtn(0)}>전체</button>
                    </div>
                </div>
                <div className="box1_content">
                    <div className="box1_row1">
                        <div className="box1_calendar">
                            <div className="calendar_table">
                                {
                                    ['월','화','수','목','금','토','일'].map(e=>(
                                        <div key={e} className="calendar_table_day">{e}</div>
                                    ))                                
                                }
                                {
                                    calendarList.length>0 && calendarList.map((item, idx) => (
                                        !item.date ? (
                                        <div key={idx} className="calendar_table_item_wrapper" />
                                        ) : (
                                        <div key={item.date} className="calendar_table_item_wrapper">
                                            <button
                                                className="calendar_table_item"
                                                onClick={()=>handleClickCalendarItem(item.date)}
                                            >
                                                <div className={`default ${diaryData[item.date] ? "checked" : ""} ${(item.date<startDate || item.date>endDate) ? "disabled" : ""}`}><span>{item.monthNum}/{item.dateNum}</span></div>             
                                            </button>
                                            {diaryData[item.date] && 'drinking' in diaryData[item.date] && diaryData[item.date].drinking==="금주" &&
                                                <div className={
                                                    `underline
                                                    ${printUnderline(idx)}`
                                                }
                                            />}
                                            {(item.date===startDate || item.date===endDate) && <div className="red_circle" />}
                                            {idx%7!==6 && item.date===startDate && item.date!==endDate && <div className="red_line start" />}
                                            {idx%7!==0 && item.date===endDate && item.date!==startDate && <div className="red_line end" />}
                                            {item.date>startDate && item.date<endDate && <div className={`red_line ${idx%7===0 ? "first" : ""} ${idx%7===6 ? "last" : ""}`} />}
                                        </div>
                                        )
                                    ))
                                }
                            </div>
                        </div>
                        <div className="box1_info">
                            <div className="info">
                                <p>금주일지</p>
                                <div>
                                    <p>{diaryInfo.diaryNum} / {diaryInfo.entireNum}</p>
                                </div>
                            </div>
                            <div className="info">
                                <p>금주</p>
                                <div>
                                    <p>{diaryInfo.doNotDrinkNum} / {diaryInfo.entireNum}</p>
                                </div>
                            </div>
                            <div className="info">
                                <p>최장<br/>연속 금주 일수</p>
                                <div>
                                    <p>{diaryInfo.maxDoNotDrinkNum} 일</p>
                                    {diaryInfo.maxDoNotDrinkStartDate && <p>( {diaryInfo.maxDoNotDrinkStartDate} ~ {diaryInfo.maxDoNotDrinkEndDate} )</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="calendar_legend">
                        <div className="calendar_legend_item">
                            <div className="legend_item_icon1" />
                            <span>금주일지 미작성</span>
                        </div>
                        <div className="calendar_legend_item">
                            <div className="legend_item_icon2" />
                            <span>금주일지 작성</span>
                        </div>
                        <div className="calendar_legend_item">
                            <div className="legend_item_icon3" />
                            <span>금주 실천</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function GraphBox1({drugIntakeData}) {

    const calculatePercentage = (targetData, otherData) => {
        const sum = targetData + otherData;

        if(!targetData || !sum){
            return 0;
        }

        // 소수점 첫째 자리까지 반올림
        return (Math.round(targetData/sum*1000)/10).toFixed(1);
    }

    return (
        <div className="diary_box2">
            <div className="box2_title">약물</div>
            <div className="box2_item_wrapper">
                <div className="box2_item">
                    <div className="item_title">복용 여부</div>
                    <div className="item_graph_wrapper">
                        <div className="graph_item" style={{ backgroundColor: '#92C254', height: `${calculatePercentage(drugIntakeData.intakeStatus.yes, drugIntakeData.intakeStatus.no)}%`}} />
                        <div className="graph_item" style={{ backgroundColor: '#EBFFC7', height: `${calculatePercentage(drugIntakeData.intakeStatus.no, drugIntakeData.intakeStatus.yes)}%`}} />
                    </div>
                    <div className="item1_graph_info">
                        <div className="info_item">
                            <div className="info_item_label">
                                <div className="info_item_label_icon" style={{backgroundColor: '#92C254'}} />
                                <span>복용</span>
                            </div>
                            <div className="info_item_value">
                                {calculatePercentage(drugIntakeData.intakeStatus.yes, drugIntakeData.intakeStatus.no)} % ({drugIntakeData.intakeStatus.yes} 회)
                            </div>
                        </div>
                        <div className="info_item">
                            <div className="info_item_label">
                                <div className="info_item_label_icon" style={{backgroundColor: '#EBFFC7'}} />
                                <span>미복용</span>
                            </div>
                            <div className="info_item_value">
                                {calculatePercentage(drugIntakeData.intakeStatus.no, drugIntakeData.intakeStatus.yes)} % ({drugIntakeData.intakeStatus.no} 회)
                            </div>
                        </div>
                    </div>
                </div>
                <div className="box2_item">
                    <div className="item_title">복용량</div>
                    <div className="item_graph_wrapper">
                        <div className="graph_item" style={{ backgroundColor: '#8ACDFB', height: `${calculatePercentage(drugIntakeData.dose.all, drugIntakeData.dose.part)}%`}} />
                        <div className="graph_item" style={{ backgroundColor: '#D4EDFF', height: `${calculatePercentage(drugIntakeData.dose.part, drugIntakeData.dose.all)}%`}} />
                    </div>
                    <div className="item1_graph_info">
                        <div className="info_item">
                            <div className="info_item_label">
                                <div className="info_item_label_icon" style={{backgroundColor: '#8ACDFB'}} />
                                <span>모두 복용</span>
                            </div>
                            <div className="info_item_value">
                                {calculatePercentage(drugIntakeData.dose.all, drugIntakeData.dose.part)} % ({drugIntakeData.dose.all} 회)
                            </div>
                        </div>
                        <div className="info_item">
                            <div className="info_item_label">
                                <div className="info_item_label_icon" style={{backgroundColor: '#D4EDFF'}} />
                                <span>일부 복용</span>
                            </div>
                            <div className="info_item_value">
                                {calculatePercentage(drugIntakeData.dose.part, drugIntakeData.dose.all)} % ({drugIntakeData.dose.part} 회)
                            </div>
                        </div>
                    </div>
                </div>
            </div>                    
        </div>
    )
}

function GraphBox2({cravingGraphData, drinkingGraphData, drinkingSituationRankData, drinkingTypeRankData}) {
    return (
        <div className="diary_row2">
            <div className="row2_box1">
                <div className="title">
                    갈망 / 음주량
                </div>
                <div className="graph_legend">
                    <div className="graph_legend_item">
                        <div className="graph_legend_item_icon">
                            <div className="graph_legend_item_icon_circle" />
                        </div>
                        갈망정도
                    </div>
                    <div className="graph_legend_item">
                        <div className="graph_legend_item_icon">
                            <div className="graph_legend_item_icon_circle" />
                        </div>
                        음주량 (잔)
                    </div>
                </div>
                <div className="graph">                    
                    <PatientDetailDiaryLineChart cravingData={cravingGraphData} drinkingData={drinkingGraphData} />
                </div>
            </div>
            <div className="row2_box2">
                <div className="box2_item">
                    <div className="item_title">
                        상황별 음주
                    </div>
                    <div className="item_content">                        
                        <div className="item_rank_wrapper">
                        {
                            drinkingSituationRankData.map((e, idx) => (
                                <div key={idx} className="item_rank">
                                    <p>{e.rank}위</p>
                                    <p>{e.situation}</p>
                                    <p>{e.percentage}% ({e.num})</p>
                                </div>
                            ))
                        }
                        </div>
                    </div>
                </div>
                <div className="box2_item">
                    <div className="item_title">
                        주종 및 음주량
                    </div>
                    <div className="item_content">                        
                        <div className="item_rank_wrapper">
                        {
                            drinkingTypeRankData.map((e, idx) => (
                                <div key={idx} className="item_rank">
                                    <p>{e.rank}위</p>
                                    <p>{e.alcohol}</p>
                                    <p>{e.percentage}% ({e.num})</p>
                                </div>
                            ))
                        }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function AlcoholDiary({setSelectedTag}) {
    const { pid } = useParams();

    // 금주일지 캘린더 날짜 리스트
    const [calendarList, setCalendarList] = useState([]);
    // 환자가 교육을 시작한 날짜 => YYYY-MM-DD
    const [educationStartDate, setEducationStartDate] = useState("");
    // 선택한 날짜 => Date 객체
    const [startDate, setStartDate]  = useState("");
    const [endDate, setEndDate] = useState("");

    // 금주일지 데이터
    const [diaryData, setDiaryData] = useState({});
    const [diaryInfo, setDiaryInfo] = useState({
        // 전체 일수
        entireNum: 0,
        // 금주일지 작성 일수
        diaryNum: 0,
        // 금주 일수
        doNotDrinkNum: 0,
        // 최장 연속 금주 일수
        maxDoNotDrinkNum: 0,
        maxDoNotDrinkStartDate: '',
        maxDoNotDrinkEndDate: ''
    })
    // 약물 복용 데이터
    const [drugIntakeData, setDrugIntakeData] = useState({
        // 복용 여부
        intakeStatus: {
            yes: 0,
            no: 0
        },
        // 복용량
        dose: {
            all: 0,
            part: 0
        }
    })
    // 그래프 데이터 - 갈망 정도
    const [cravingGraphData, setCravingGraphData] = useState([]);
    // 그래프 데이터 - 음주량
    const [drinkingGraphData, setDrinkingGraphData] = useState([]);
    // 랭킹 데이터 - 상황별 음주
    const [drinkingSituationRankData, setDrinkingSituationRankData] = useState([]);
    // 랭킹 데이터 - 주종 및 음주
    const [drinkingTypeRankData, setDrinkingTypeRankData] = useState([]);

    // 달력 날짜 클릭 -> startDate와 endDate 중 더 가까운 날짜가 이동함
    const handleClickCalendarItem = (date) => {
        const startDiff = getDateDiff(convertDateString(startDate), convertDateString(date));
        const endDiff = getDateDiff(convertDateString(endDate), convertDateString(date));

        if(getDateDiff(convertDateString(startDate), convertDateString(endDate))===2 && (date===startDate || date===endDate)){
            setStartDate(date);
            setEndDate(date);
            return;
        }

        if(startDate===endDate){
            if(date<startDate){
                setStartDate(date);
            }else{
                setEndDate(date);
            }
        }else if(startDiff<endDiff){
            setStartDate(date);
        }else{
            setEndDate(date);
        }
    }

    // 데이터 변수들 초기화
    function initializeData() {
        setDiaryData({});
        setDiaryInfo({
            entireNum: 0,
            diaryNum: 0,
            doNotDrinkNum: 0,
            maxDoNotDrinkNum: 0,
            maxDoNotDrinkStartDate: '',
            maxDoNotDrinkEndDate: ''
        });
        setDrugIntakeData({
            intakeStatus: {
                yes: 0,
                no: 0
            },
            dose: {
                all: 0,
                part: 0
            }
        });
        setCravingGraphData([]);
        setDrinkingGraphData([]);
        setDrinkingSituationRankData([]);
        setDrinkingTypeRankData([]);
    }

    // diaryInfo 매핑
    function mappingDiaryInfo(originalData, newDoNotDrinkNum=0) {
        try {
            const newEntireNum = getDateDiff(educationStartDate, convertDateString(endDate));

            const newMaxDoNotDrinkStartDate = originalData[0].noDrinkingStart ? `${Number(originalData[0].noDrinkingStart.slice(4,6))}/${Number(originalData[0].noDrinkingStart.slice(6,8))}` : "";
            const newMaxDoNotDrinkEndDate = originalData[0].noDrinkingEnd ? `${Number(originalData[0].noDrinkingEnd.slice(4,6))}/${Number(originalData[0].noDrinkingEnd.slice(6,8))}` : "";

            setDiaryInfo({
                ...diaryInfo,
                entireNum: newEntireNum,
                diaryNum: originalData.length,
                doNotDrinkNum: newDoNotDrinkNum,
                maxDoNotDrinkNum: originalData[0].numDaysNoDrinking || 0,
                maxDoNotDrinkStartDate: newMaxDoNotDrinkStartDate,
                maxDoNotDrinkEndDate: newMaxDoNotDrinkEndDate
            })
        }catch(err){
            console.error(err);
            setDiaryInfo({
                entireNum: 0,
                diaryNum: 0,
                doNotDrinkNum: 0,
                maxDoNotDrinkNum: 0,
                maxDoNotDrinkStartDate: '',
                maxDoNotDrinkEndDate: ''
            })
        }
    }

    // drinkingTypeRank 매핑
    function mappingDrinkingTypeRankData(originalData) {
        try{
            let newDrinkingTypeRankData = [];
            if(originalData[0].alcoholsRank) {
                const drinkingTypeRankArr = originalData[0].alcoholsRank.split(/,|:/);
                if(drinkingTypeRankArr.length>0){
                    let totalNum = 0;
                    for(let i=0;i<drinkingTypeRankArr.length;i+=2){
                        newDrinkingTypeRankData.push({
                            alcohol: drinkingTypeRankArr[i+1],
                            num: Number(drinkingTypeRankArr[i])
                        });
                        totalNum+=Number(drinkingTypeRankArr[i]);
                    }
                    // 음주량으로 sort
                    newDrinkingTypeRankData.sort((a,b)=>b.num-a.num || a.alcohol.localeCompare(b.alcohol));

                    let curRank = 0;
                    let prevNum = -1;
                    newDrinkingTypeRankData = newDrinkingTypeRankData.map(e=>{
                        if(prevNum!==e.num){
                            curRank++;
                            prevNum = e.num;
                        }

                        return {
                            ...e,
                            rank: curRank,
                            percentage: Math.round(e.num/totalNum*1000)/10
                        }
                    })
                }
            }
            setDrinkingTypeRankData(newDrinkingTypeRankData);
        }catch(err){
            console.error(err);
            setDrinkingTypeRankData([]);
        }
    }

    // drinkingSituationRankData 매핑
    function mappingDrinkingSituationRankData(obj, totalNum) {
        try{
            let newDrinkingSituationRankData = [];
            Object.keys(obj).forEach(key=> {
                newDrinkingSituationRankData.push({
                    situation: key,
                    num: Number(obj[key]),
                    percentage: Math.round(Number(obj[key])/totalNum*1000)/10
                })
            })

            // sort
            newDrinkingSituationRankData.sort((a,b)=>b.num-a.num || a.situation.localeCompare(b.situation));

            let curRank = 0;
            let prevNum = -1;
            newDrinkingSituationRankData = newDrinkingSituationRankData.map(e=>{
                if(prevNum!==e.num){
                    curRank++;
                    prevNum = e.num;
                }

                return {
                    ...e,
                    rank: curRank,
                    percentage: Math.round(e.num/totalNum*1000)/10
                }
            })

            setDrinkingSituationRankData(newDrinkingSituationRankData);
        }catch(err){
            console.error(err);
            setDrinkingSituationRankData([]);
        }
    }


    async function getDiaryDataFromAPI() {
        try{
            const request = {
                pid,
                start: startDate,
                end: endDate
            }
            const res = await getDoNotDrinkDiaryFromAlcohol(request);
            
            if(parseInt(res.status/200,10)===1){
                if(res.data.length>0){
                    let newDoNotDrinkNum = 0;
                    
                    const diaryObj = {};
                    const newDrugIntakeData = {
                        // 복용 여부
                        intakeStatus: {
                            yes: 0,
                            no: 0
                        },
                        // 복용량
                        dose: {
                            all: 0,
                            part: 0
                        }
                    };
                    const newCravingGraphData = [];
                    const newDrinkingGraphData = [];
                    const newDrinkingSituationRankObj = {};
                    let totalDrinkSituationNum = 0;
                    // 금주, 약물 데이터 매핑
                    res.data.forEach(e=>{
                        if(e.journalDate){
                            diaryObj[e.journalDate]={
                                drinking: e.drinkingName
                            }
                        }                        

                        if(e.situationName) {
                            if(e.situationName in newDrinkingSituationRankObj){
                                newDrinkingSituationRankObj[e.situationName]++;
                            }else{
                                newDrinkingSituationRankObj[e.situationName] = 1;
                            }
                            totalDrinkSituationNum++;
                        }

                        // 그래프 데이터 매핑
                        if(e.journalDate){
                            const dayList = ['일', '월', '화', '수', '목', '금', '토'];
                            const dateObj = new Date(convertDateString(e.journalDate));

                            newCravingGraphData.push({
                                date: dateObj ? `${dateObj.getMonth()+1}/${dateObj.getDate()}(${dayList[dateObj.getDay()]})` : e.journalDate,
                                num: e.cravingStage || 0
                            })

                            newDrinkingGraphData.push({
                                date: dateObj ? `${dateObj.getMonth()+1}/${dateObj.getDate()}(${dayList[dateObj.getDay()]})` : e.journalDate,
                                num: e.amtAlcohol || 0
                            })
                        }

                        if(e.drinkingName==="금주") newDoNotDrinkNum++;
                        if(e.drugIntakeName==="모두 복용") {
                            newDrugIntakeData.intakeStatus.yes++;
                            newDrugIntakeData.dose.all++;
                        }else if(e.drugIntakeName==="일부 복용"){
                            newDrugIntakeData.intakeStatus.yes++;
                            newDrugIntakeData.dose.part++;
                        }else if(e.drugIntakeName==="미복용"){
                            newDrugIntakeData.intakeStatus.no++;
                        }
                    })
    
                    setDiaryData(diaryObj);
                    setDrugIntakeData(newDrugIntakeData);
                    setCravingGraphData(newCravingGraphData);
                    setDrinkingGraphData(newDrinkingGraphData);

                    // 상황별 음주 랭킹 데이터 매핑
                    mappingDrinkingSituationRankData(newDrinkingSituationRankObj, totalDrinkSituationNum);

                    // 주종 및 음주량 랭킹 데이터 매핑
                    mappingDrinkingTypeRankData(res.data);                    
    
                    // diaryInfo 데이터 매핑
                    mappingDiaryInfo(res.data, newDoNotDrinkNum);                  
                }else{
                    initializeData();
                }               
            }else{
                throw new Error();
            }

        }catch(err){
            console.error(err);
        }
    }

    // default로 환자가 처음 교육을 시작한 날 ~ 오늘 날짜를 표시
    function initializeDate() {
        const today = new Date();
        setStartDate(educationStartDate.split('-').join(''));

        // 오늘 날짜가 (최초 교육 시작 날짜 + 8주)를 벗어나면, endDate를 (최초 교육 시작 날짜 + 8주)로 설정함.
        const maxDate = new Date(educationStartDate);
        maxDate.setDate(maxDate.getDate()+55);
        if(convertDate(maxDate)<convertDate(today)){
            setEndDate(convertDate(maxDate));
        }else{
            setEndDate(convertDate(today));
        }        
    }

    function initializeCalendarList() {
        const dayList = ['일', '월', '화', '수', '목', '금', '토'];
        const date = new Date(educationStartDate);
        const firstDay = date.getDay()===0 ? 7 : date.getDay();
        const newCalendarList = [];

        for(let i=1;i<firstDay;i++){
            newCalendarList.push({
                date: ""
            })
        }

        // 환자 교육 시작 날짜부터 2주
        for(let i=0;i<56;i++){
            const dateString = convertDate(date);
            newCalendarList.push({
                date: dateString,
                monthNum: date.getMonth()+1,
                dateNum: date.getDate(),
                day: dayList[date.getDay()]
            })
            date.setDate(date.getDate()+1);
        }        

        setCalendarList(newCalendarList);
    }

    // 기간 선택 버튼 => 1(1주), 2(2주), 4(4주), 0(전체)
    const handleClickWeekBtn = (type) => {
        const dateObj = new Date(educationStartDate);

        if(type===1){
            dateObj.setDate(dateObj.getDate()+6);
        }else if(type===2){
            dateObj.setDate(dateObj.getDate()+13);
        }else if(type===4){
            dateObj.setDate(dateObj.getDate()+27);
        }else{
            dateObj.setDate(dateObj.getDate()+55);
        }

        setStartDate(educationStartDate.split('-').join(''));
        setEndDate(convertDate(dateObj));
    }

    useEffect(()=>{
        // 세션에 firstTrainingStart 정보가 없으면 교육 현황 탭으로 이동 
        const firstTrainingStart = sessionStorage.getItem('firstTrainingStart');
        if(firstTrainingStart) {
            setEducationStartDate(convertDateString(firstTrainingStart));
        }else{
            alert("해당 환자는 금주 일지 정보가 존재하지 않습니다.");
            setSelectedTag("education");
        }
    },[])

    useEffect(()=>{
        if(educationStartDate){
            initializeDate(); 
        }               
    },[educationStartDate])

    useEffect(()=>{
        if(educationStartDate){
            initializeCalendarList();
        }        
    },[educationStartDate, diaryData])

    useEffect(()=>{
        if(startDate && endDate){
            getDiaryDataFromAPI();
        }        
    },[startDate, endDate])
    
    return (
        <div className="patientResult__diary">
            <div className="diary_row1">  
                <CalendarBox
                    calendarList={calendarList}
                    diaryData={diaryData}
                    diaryInfo={diaryInfo}
                    startDate={startDate}
                    endDate={endDate}
                    handleClickWeekBtn={handleClickWeekBtn}
                    handleClickCalendarItem={handleClickCalendarItem}
                />              
                <GraphBox1 drugIntakeData={drugIntakeData} />
            </div>            
            <GraphBox2
                cravingGraphData={cravingGraphData}
                drinkingGraphData={drinkingGraphData}
                drinkingSituationRankData={drinkingSituationRankData}
                drinkingTypeRankData={drinkingTypeRankData}
            />
        </div>
    );
}

export default AlcoholDiary;